import axios from 'axios';

export default interface Config {
  dataWizardEnabled: boolean;
  testAutomationEnabled: boolean;
}

export function loadConfig(): Promise<Config> {
  return axios.get('/config/config.json').then(response => response.data);
}
